// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import {parse} from 'date-fns';

import {Block, FormField} from './../LayoutComponents';

type AlternativeDateRangeSelectProps = {
	getLabel: (key: string) => string;
}
export default ({getLabel}: AlternativeDateRangeSelectProps) => {
	const {getValues, watch} = useFormContext();

	const now = new Date();
	const tenYears = new Date(now.getFullYear() + 10, 11, 31);

	const nameFrom = 'quoteRequest.alternativeArrivalTime';
	const nameTo = 'quoteRequest.alternativeDepartureTime';

	const {[nameFrom]: valueFrom, [nameTo]: valueTo} = getValues();
	const parseDateString = (dateString: string|undefined) => dateString
		? parse(dateString, 'dd.MM.yyyy', new Date())
		: undefined;

	watch(nameFrom);
	watch(nameTo);

	return (
		<Block>
			<Block half>
				<FormField
					type="DateInput"
					name={nameFrom}
					label={getLabel('quoteRequest.alternativeArrivalTime')}
					required
					minDate={now}
					maxDate={parseDateString(valueTo) || tenYears}
				/>
			</Block>
			<Block half>
				<FormField
					type="DateInput"
					name={nameTo}
					label={getLabel('quoteRequest.alternativeDepartureTime')}
					required
					minDate={parseDateString(valueFrom) || now}
					maxDate = {tenYears}
				/>
			</Block>
		</Block>
	);
}
